<div class="grid h-full w-full grid-rows-2 gap-1">
  <lib-arch-row
    [teeth]="teeth()"
    [selectedTeethPositions]="selectedTeethPositions()"
    [drawTreatments]="drawTreatments()"
    [arch]="'maxillary'"
    [leftQuadrant]="Quadrant.TopRight"
    [rightQuadrant]="Quadrant.TopLeft"
    [mode]="mode()"
    [isSelected]="selectedArch().includes('maxillary')"
    [selectedQuadrant]="selectedQuadrant()"
    (archClicked)="archClicked.emit($event)"
    (quadrantClicked)="quadrantClicked.emit($event)"
    (toothClicked)="toothClicked.emit($event)"
  />
  <lib-arch-row
    [teeth]="teeth()"
    [selectedTeethPositions]="selectedTeethPositions()"
    [drawTreatments]="drawTreatments()"
    [arch]="'mandibular'"
    [leftQuadrant]="Quadrant.BottomRight"
    [rightQuadrant]="Quadrant.BottomLeft"
    [mode]="mode()"
    [isSelected]="selectedArch().includes('mandibular')"
    [selectedQuadrant]="selectedQuadrant()"
    (archClicked)="archClicked.emit($event)"
    (quadrantClicked)="quadrantClicked.emit($event)"
    (toothClicked)="toothClicked.emit($event)"
  />
</div>
